import Vue from "vue";
import VueI18n from "vue-i18n";

import { Locale } from 'vant';

import { getLanguage, setLanguage } from "@/utils/cookies";
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';


import zh from "./zh";
import en from "./en";
import zhTW from "./zh-TW";
import ko from "./ko";
import ja from "./ja";


Vue.use(VueI18n);

const messages = {
  'zh': {
    ...zh,
    ...zhCN
  },
  'en': {
    ...en,
    ...enUS
  },
  'zh-TW': {
    ...zhTW,
    ...zhCN
  },
  'ko': {
    ...ko,
    ...enUS
  },
  'ja': {
    ...ja,
    ...enUS
  }
};
export const getLocale = () => {
  const cookieLanguage = getLanguage();
  if (cookieLanguage) {
    document.documentElement.lang = cookieLanguage;
    return cookieLanguage;
  }

  const language = navigator.language.toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      document.documentElement.lang = locale;
      return locale;
    }
  }

  return "zh";
};

const CURRENT_LANG = getLocale();
console.log(CURRENT_LANG)
Locale.use(CURRENT_LANG, messages[CURRENT_LANG])

const i18n = new VueI18n({
  locale: CURRENT_LANG,
  messages
});


export const setI18nLanguage = lang => {
  i18n.locale = lang;
  document.documentElement.lang = lang;
  setLanguage(lang);
  Locale.use(lang, messages[lang]);
  return lang;
};

export default i18n;